module.exports = __webpack_public_path__ + "img/rules-tko.82268d13.jpg";